module.exports = __webpack_public_path__ + "img/emoji_70.872a2499.png";